<template>
  <div class="md:flex md:items-center md:justify-between mb-3">
    <div class="flex-1 min-w-0">
      <h2 class="text-xl font-bold tracking-tight text-foreground lg:text-2xl">
        Fournisseur
      </h2>
    </div>
    <div class="mt-4 flex md:mt-0 md:ml-4">
      <div class="relative rounded-md shadow-sm">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <SearchIcon
              class="h-5 w-5 text-gray-400"
              aria-hidden="true"
          />
        </div>
        <form id="search">
          <input
              v-model="searchQuery"
              type="text"
              name="query"
              class="inline-flex focus:ring-indigo-500  px-4  py-2 focus:border-indigo-500 block w-full min-w-0  pl-10 sm:text-sm border-gray-300 rounded-md"
              @input="saveToLocalStorage('filterKey', $event.target.value)"
          >
        </form>
      </div>

      <button
          class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          type="button"
          @click="showAdd = true"
      >
        Ajouter
      </button>
    </div>
  </div>
  <div class="mt-4 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-hidden sm:-mx-6 lg:-mx-8 grid mt-2">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
          <CompanyGrid
              :data1="gridData"
              :columns="gridColumns"
              :columns-displayed="gridColumnsDisplayed"
              :filter-key="searchQuery"
              :page="1"
              :per-page="11"
              :pages="[]"
          />
        </div>
      </div>
    </div>
  </div>
  <TransitionRoot as="template" :show="showAdd">
    <CompanyAdd @close="showAdd = false" @created="fetchCompanyData"></CompanyAdd>
  </TransitionRoot>

</template>

<script setup>

import {CreditCardIcon, OfficeBuildingIcon, SearchIcon, UserIcon, UsersIcon} from '@heroicons/vue/solid'
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
</script>


<script>
import CompanyAdd from './CompanyAdd.vue'
import CompanyGrid from './CompanyGrid.vue'
import axios from "axios";
import moment from 'moment'


export default {
  components: {
    CompanyGrid,
    CompanyAdd
  },
  props: {
    endpoint: String,
  },
  data: () => ({
    showAdd: false,
    gridColumnsDisplayed: {
      from_name: "Fournisseur",
      country: "Pays",
      website: "Site Web",
    },
    polling: null,
    gridColumns: ['from_name', 'country', 'website'],
    gridData: [],
    searchQuery: '',
  }),
  mounted() {
    this.searchQuery = this.getFromLocalStorage('filterKey')
    this.fetchCompanyData()
    this.intervalFetchData()
  },
  beforeUnmount () {
    clearInterval(this.polling)
  },
  methods: {
    intervalFetchData: function () {
      this.polling = setInterval(() => {
        this.fetchCompanyData();
      }, 10000);
    },
    saveToLocalStorage(item, value) {
      localStorage.setItem(item, value);
    },
    getFromLocalStorage(item) {
      return localStorage.getItem(item);
    },
    async fetchCompanyData() {
      const token = await this.$auth.getAccessTokenSilently();
      const HTTP = axios.create({
        baseURL: `https://billing.clafoutis.eu/api`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      HTTP.get(this.endpoint)
          .then(response => {
            const {companys} = response.data
            const gridData = []
            companys.forEach((value) => {
              gridData.push({
                id: value['id'],
                name: value['name'] ? value['name'] : null,
                country: value['country'] ? value['country'] : null,
                sector: value['sector'] ? value['sector'] : null,
                website: value['website']  ? value['website'] : null,
                created_at: value['created_at'] ? moment(value['created_at']).format('YYYY-MM-DD') : null,
                no_invoice: value['no_invoice'] ? value['no_invoice'] : null,
                button: value['id'],
                company_name: value['name'] ? value['name'] : null,
                company_avatar: value['avatar'] && value['avatar'] != null ? value['avatar'] : 'https://cdn1.iconfinder.com/data/icons/unicons-line-vol-2/24/cloud-question-512.png',
                company_website: value['website'] && value['website'] != null ? value['website'] : null,

              })
            });

            // Trier par ID, plus grand en haut
            gridData.sort((a, b) => {
              const idA = a.id;
              const idB = b.id;
              if (typeof idA === 'string' && typeof idB === 'string') {
                return idB.localeCompare(idA);
              }
              return idB - idA;
            });

            this.gridData = gridData
          })

          .catch(e => {
            console.log(e)
          })
    },
    truncate(v) {
      const newline = v.indexOf('\n')
      return newline > 0 ? v.slice(0, newline) : v
    },
    formatDate(v) {
      return v.replace(/T|Z/g, ' ')
    }
  }
}
</script>
